module.exports = __webpack_public_path__ + "img/maintenance-old.feb3ff95.png";